// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1spOu","right":"Footer_right__22g7m","buttons":"Footer_buttons__2i7wK"};